import angular from 'angular';
import * as actions from './message.actions';
import { messageMiddleware } from './message.middleware';

export { actions };

export const MESSAGE_MIDDLEWARE = 'updMessageMiddleware';

export const MessageModule = angular
  .module('app.state.messages.middleware', [])
  .service(MESSAGE_MIDDLEWARE, messageMiddleware);
